import { mountGame } from '../render/three/game-app.js';
import { yukonSpec } from '../variants/yukon/spec.js';

await mountGame(yukonSpec);
